var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Isolation_Mode",
    "data-name": "Isolation Mode",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.83,16.75c-.32,0-.58-.26-.58-.58s.26-.58.58-.58h15.35c.32,0,.58.26.58.58s-.26.58-.58.58H.83ZM8.5.25c-.32,0-.58.26-.58.58v9.35l-2.85-2.85c-.22-.22-.59-.22-.81,0s-.22.59,0,.81l3.84,3.84c.11.11.26.17.41.17s.29-.06.41-.17l3.84-3.84c.22-.22.22-.59,0-.81s-.59-.22-.81,0l-2.85,2.85V.83c0-.32-.26-.58-.58-.58Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.f3afd509194d1c331a1cb5b036e2856f.svg";
export { ForwardRef as ReactComponent };